<template>
  <div class="clerk-management-page">
    <!-- 页面头部 -->
    <page-header>
      <div>达康药店的员工列表</div>
    </page-header>

    <!-- 搜索和筛选区域 -->
    <div class="filter-area">
      <el-card class="filter-card">
        <el-form :model="filterForm" ref="filterFormRef" inline label-width="80px">
          <el-form-item label="员工姓名" prop="name">
            <el-input
                v-model="filterForm.name"
                placeholder="请输入姓名"
                clearable
                style="width: 200px"
                @keyup.enter.native="handleSearch"
            />
          </el-form-item>

          <el-form-item label="手机号" prop="phone">
            <el-input
                v-model="filterForm.phone"
                placeholder="请输入手机号"
                clearable
                style="width: 200px"
                @keyup.enter.native="handleSearch"
            />
          </el-form-item>

          <el-form-item label="店铺名称" prop="merchantName">
            <el-input
                v-model="filterForm.merchantName"
                placeholder="请输入店铺名称"
                clearable
                style="width: 200px"
                @keyup.enter.native="handleSearch"
            />
          </el-form-item>

          <el-form-item label="员工状态" prop="status">
            <el-select
                v-model="filterForm.status"
                placeholder="请选择状态"
                clearable
                style="width: 120px"
                @change="handleSearch"
            >
              <el-option label="在职" :value="1" />
              <el-option label="休假" :value="2" />
              <el-option label="离职" :value="3" />
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleSearch">
              <i class="el-icon-search"></i>搜索
            </el-button>
            <el-button @click="resetFilter">
              <i class="el-icon-refresh"></i>重置
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <!-- 员工列表 -->
    <table-union-pager
        :data="tableData"
        @current-change="handlePageChange"
    >
      <el-table-column label="ID" property="id" width="80" align="center"/>

      <el-table-column label="店铺名称" property="merchantName" min-width="150" show-overflow-tooltip/>

      <el-table-column label="姓名" property="name" min-width="100"/>

      <el-table-column label="用户名" property="username" min-width="120"/>

      <el-table-column label="手机号" property="phone" min-width="120"/>

      <el-table-column label="角色" min-width="80">
        <template #default="scope">
          <el-tag :type="scope.row.isMainAccount ? 'success' : 'info'" size="small">
            {{ scope.row.isMainAccount ? '店长' : '普通员工' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="状态" min-width="80">
        <template #default="scope">
          <el-tag :type="getStatusType(scope.row.status)" size="small">
            {{ getStatusText(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="返利比例" min-width="100">
        <template #default="scope">
          <span :class="{'highlight-value': scope.row.rebateRatio > 0}">
            {{ scope.row.rebateRatio ? scope.row.rebateRatio + '%' : '--' }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="累计佣金" min-width="120">
        <template #default="scope">
          <div :class="{'highlight-value': scope.row.totalCommission > 0}">
            {{ scope.row.totalCommission ? ((scope.row.totalCommission / 100).toFixed(2)) + '元' : '--' }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="添加时间" min-width="160">
        <template #default="scope">
          {{ formatTime(scope.row.addDataTime) }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="150" fixed="right">
        <template #default="scope">
          <el-button type="text" @click="viewDetail(scope.row)">详情</el-button>
          <el-button type="text" @click="resetPassword(scope.row)">重置密码</el-button>
        </template>
      </el-table-column>
    </table-union-pager>

    <!-- 员工详情弹窗 -->
    <el-dialog
        :visible.sync="detailDialog.visible"
        title="员工详情"
        append-to-body
        :close-on-click-modal="false"
        width="600px"
        top="20px"
    >
      <el-form label-width="100px" :model="detailDialog.detail">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="员工姓名">
              <span>{{ detailDialog.detail.name || '--' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户名">
              <span>{{ detailDialog.detail.username || '--' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="手机号">
              <span>{{ detailDialog.detail.phone || '--' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属店铺">
              <span>{{ detailDialog.detail.merchantName || '--' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="员工角色">
              <el-tag :type="detailDialog.detail.isMainAccount ? 'success' : 'info'" size="small">
                {{ detailDialog.detail.isMainAccount ? '店长' : '普通员工' }}
              </el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="员工状态">
              <el-tag :type="getStatusType(detailDialog.detail.status)" size="small">
                {{ getStatusText(detailDialog.detail.status) }}
              </el-tag>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="返利比例">
              <span>{{ detailDialog.detail.rebateRatio || 0 }}%</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="累计佣金">
              <span>{{ detailDialog.detail.totalCommission ? ((detailDialog.detail.totalCommission / 100).toFixed(2)) + '元' : '0元' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="入职日期">
              <span>{{ formatTime(detailDialog.detail.hireDate) || '--' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最后登录">
              <span>{{ formatTime(detailDialog.detail.lastLoginTime) || '--' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialog.visible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TableUnionPager from "@/components/TableUnionPager";
import PageHeader from "@/components/PageHeader";
import api from "@/utils/api";

export default {
  name: "Clerks",
  components: {
    TableUnionPager,
    PageHeader
  },
  data() {
    return {
      tableData: {
        list: [],
        totalCount: 0,
        page: 1,
        pageSize: 10,
        loading: false
      },

      filterForm: {
        name: '',
        phone: '',
        merchantName: '',
        status: null
      },

      detailDialog: {
        visible: false,
        detail: {}
      }
    };
  },
  mounted() {
    this.loadClerks();
  },
  methods: {
    async loadClerks() {
      try {
        this.tableData.loading = true;

        const params = {
          page: this.tableData.page,
          pageSize: this.tableData.pageSize
        };

        // 构建搜索条件
        if (this.filterForm.name) {
          params.search = this.filterForm.name;
        }
        if (this.filterForm.phone) {
          params.search = params.search ? `${params.search},${this.filterForm.phone}` : this.filterForm.phone;
        }
        if (this.filterForm.merchantName) {
          params.merchantName = this.filterForm.merchantName;
        }
        if (this.filterForm.status) {
          params.status = this.filterForm.status;
        }

        const res = await api.clerk_getAllClerks(params);

        // 处理 api 返回的数据结构
        const responseData = res.data || res;

        if (responseData && responseData.code === "000" && responseData.data) {
          this.tableData.list = responseData.data.list || [];
          this.tableData.totalCount = responseData.data.totalCount || 0;
        } else {
          this.$message.error(responseData?.message || '加载员工列表失败');
        }
      } catch (error) {
        console.error('加载员工列表失败:', error);
        this.$message.error('加载员工列表失败');
      } finally {
        this.tableData.loading = false;
      }
    },

    handlePageChange(page) {
      this.tableData.page = page;
      this.loadClerks();
    },

    handleSearch() {
      this.tableData.page = 1;
      this.loadClerks();
    },

    resetFilter() {
      this.$refs.filterFormRef?.resetFields();
      this.filterForm = {
        name: '',
        phone: '',
        merchantName: '',
        status: null
      };
      this.tableData.page = 1;
      this.loadClerks();
    },

    getStatusType(status) {
      const map = {
        1: 'success',
        2: 'warning',
        3: 'danger'
      };
      return map[status] || 'info';
    },

    getStatusText(status) {
      const map = {
        1: '在职',
        2: '休假',
        3: '离职'
      };
      return map[status] || '未知';
    },

    formatTime(timestamp) {
      if (!timestamp) return '--';
      const date = new Date(timestamp);
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
    },

    viewDetail(row) {
      this.detailDialog.detail = { ...row };
      this.detailDialog.visible = true;
    },

    async resetPassword(row) {
      this.$confirm(`确认重置员工"${row.name}"的密码吗？重置后新密码将发送到员工手机。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await api.seller_resetPassword({ id: row.id });
          const responseData = res.data || res;
          if (responseData && responseData.code === "000") {
            this.$message.success('密码重置成功！新密码已发送到员工手机');
          } else {
            this.$message.error(responseData?.message || '重置密码失败');
          }
        } catch (error) {
          console.error('重置密码失败:', error);
          this.$message.error('重置密码失败');
        }
      }).catch(() => {
        this.$message.info('已取消重置');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.clerk-management-page {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.filter-area {
  margin-bottom: 20px;

  .filter-card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);

    :deep(.el-form-item) {
      margin-bottom: 0;
      margin-right: 16px;
    }
  }
}

.highlight-value {
  color: #e6a23c;
  font-weight: 500;
}

.dialog-footer {
  text-align: right;
}

:deep(.el-table__header-wrapper) {
  .el-table-column--sortable {
    .cell {
      display: flex;
      align-items: center;

      .caret-wrapper {
        margin-left: 4px;
      }
    }
  }
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

@media (max-width: 1200px) {
  .filter-area {
    :deep(.el-form-item) {
      margin-bottom: 12px;
      margin-right: 12px;
    }
  }
}

@media (max-width: 768px) {
  .filter-area {
    :deep(.el-form-item) {
      width: 100%;
      margin-right: 0;

      .el-form-item__content {
        width: 100%;

        .el-input,
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
</style>